<template>
  <div style="text-align: center; margin: auto">
    <h2>Thank you for your {{ orderType }}</h2>
    <p class="tdesk-paragraph-large tdesk-neutral-dark">
      <strong>
        Your order has been successfully completed.
      </strong>
    </p>
    <p class="tdesk-paragraph-large tdesk-neutral-dark">
      <strong>
        You will receive an e-mail with further instructions.
      </strong>
    </p>
    <i class="fas fa-check-circle success" style="margin: 50px 0; font-size: 100px" />
    <p v-if="!userLoggedIn" class="tdesk-paragraph-large tdesk-neutral-dark">
      <strong>
        You can <a :href="`/login`">Login To Training Desk</a>
      </strong>
    </p>
    <div v-else>
      <p class="tdesk-paragraph-large tdesk-neutral-dark">
        <strong>
          You can <a :href="`/`">continue to Training Desk</a>
        </strong>
      </p>
      <div v-if="enrollingSelf">
        <p class="tdesk-paragraph-large tdesk-neutral-dark">
          <strong>
            OR
          </strong>
        </p>
        <p class="tdesk-paragraph-large tdesk-neutral-dark">
          <strong>
            Switch to your student profile to <a href="#" @click.prevent="switchToStudentProfile">complete your course</a>
          </strong>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      currentUserInformation: { type: String, required: true },
      organizer: { type: Object, required: true },
      isFreeCourse: { type: Boolean, required: true },

    },

    data() {
      const parsedUserInformation = JSON.parse(this.currentUserInformation);

      return {
        userLoggedIn: parsedUserInformation.existing_account,
        enrollingSelf: this.organizer.enrolling_self,
        loggedInProfileType: parsedUserInformation.profile_type,
        studentId: parsedUserInformation.student_id,
      };
    },

    computed: {
      orderType() {
        return this.isFreeCourse ? 'registration' : 'purchase';
      },
    },

    methods: {
      switchToStudentProfile() {
        window.axios.post('/switch_profile', {
          current_profile: 'student',
          profile_entity_id: this.studentId,
        })
        .then(() => {
          window.location.href = '/learner';
        })
        .catch(() => {
          alert('An error occurred while switching profiles. Please try again.');
        });
      },
    },
  };
</script>
